import { createAction } from 'redux-act';

import * as dashboard from '../../core/dashboard';


export const setMetrics = createAction(
  'set metrics',
);

export const setInsights = createAction(
  'set insights',
);

export const fetchPerformance = createAction(
  'get performance',
);

export const fetchPerformanceSuccess = createAction(
  'get performance success',
);

export const fetchPerformanceFail = createAction(
  'get performance fail',
  (error) => error
);

export const filterTablePerformance = createAction(
  'get table performance',
);

export const fetchTablePerformance = createAction(
  'get table performance',
);

export const fetchTablePerformanceSuccess = createAction(
  'get table performance success',
);

export const fetchTablePerformanceFail = createAction(
  'get table performance fail',
  (error) => error
);

export const setFilter = createAction(
  'set reports filter'
);

export const setBreakdown = createAction(
  'set reports breakdown'
);

export const setPeriod = createAction(
  'set reports period'
);

export const fetchFiltersData = createAction(
  'get dashboard filters'
);

export const fetchFiltersDataSuccess = createAction(
  'get dashboard filters success'
);

export const fetchFiltersDataFail = createAction(
  'get dashboard filters fail',
  (error) => error
);

export const changeShouldSidebarBeShown = createAction(
  'change shouldSidebarBeShown',
);

export const fetchInsights = createAction(
  'get insights',
);

export const fetchInsightsSuccess = createAction(
  'get insights success',
);

export const fetchInsightsFail = createAction(
  'get insights fail',
  (error) => error
);

export const reducer = {
  [setMetrics]: (state, payload) =>
    dashboard.setMetrics(state, payload),
  [setInsights]: (state, payload) =>
    dashboard.setInsights(state, payload),
  [fetchPerformance]: (state, payload) =>
    dashboard.fetchPerformance(state, payload),
  [fetchPerformanceSuccess]: (state, payload) =>
    dashboard.fetchPerformanceSuccess(state, payload),
  [fetchTablePerformance]: (state, payload) =>
    dashboard.fetchTablePerformance(state, payload),
  [filterTablePerformance]: (state, payload) =>
    dashboard.filterTablePerformance(state, payload),
  [fetchTablePerformanceSuccess]: (state, payload) =>
    dashboard.fetchTablePerformanceSuccess(state, payload),
  [setFilter]: (state, payload) =>
    dashboard.setFilter(state, payload),
  [setBreakdown]: (state, payload) =>
    dashboard.setBreakdown(state, payload),
  [setPeriod]: (state, payload) =>
    dashboard.setPeriod(state, payload),
  [fetchFiltersDataSuccess]: (state, payload) =>
    dashboard.fetchFiltersDataSuccess(state, payload),
  [changeShouldSidebarBeShown]: (state, payload) =>
    dashboard.changeShouldSidebarBeShown(state, payload),
  [fetchInsights]: (state, payload) =>
    dashboard.fetchInsights(state, payload),
  [fetchInsightsSuccess]: (state, payload) =>
    dashboard.fetchInsightsSuccess(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/dashboard.module.js
 **/